import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';

import { User, Vehicle, VehicleInsurance } from '@models';
import { VehicleInsuranceDocumentComponent } from '../vehicle-insurance-document/vehicle-insurance-document.component';

@Component({
  selector: 'app-vehicle-insurance-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatExpansionModule,
    MatDividerModule,
    VehicleInsuranceDocumentComponent,
  ],
  templateUrl: './vehicle-insurance.dialog.html',
  styleUrl: './vehicle-insurance.dialog.scss',
})
export class VehicleInsuranceDialog {
  vehicleInfoExpanded = false;

  public user?: User;
  public vehicle: Vehicle;
  public insurance: VehicleInsurance;

  constructor(
    public dialogRef: MatDialogRef<VehicleInsuranceDialog>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      user?: User;
      vehicle: Vehicle;
      vehicleInsurance: VehicleInsurance;
    }
  ) {
    this.user = data.user;
    this.vehicle = data.vehicle;
    this.insurance = data.vehicleInsurance;
  }

  onClose() {
    this.dialogRef.close();
  }

  getFormattedDate(date: Date | string | undefined): string {
    if (!date) return '';
    const d = new Date(date);
    return d.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  getInsuranceDate(): string {
    const date =
      this.data.vehicleInsurance?.updatedAt ||
      this.data.vehicleInsurance?.createdAt;
    return this.getFormattedDate(date);
  }

  getDriverName(): string {
    const profile = this.vehicle?.user?.profile;
    if (!profile) return '';
    return `${profile.firstName} ${profile.lastName}`;
  }
}
